import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from '@/locales/en'
import zhLocale from '@/locales/zh-cn'
import appConfig from '@/common/config.js';
// import store from '@/store';

let language = window.localStorage.getItem("lang");

if(!language){
	language = appConfig.defaultLang;
}

console.log("language", language)

Vue.use(VueI18n)

const messages = {
  'en': {
    ...enLocale,
  },
  'zh-cn': {
    ...zhLocale
  }
}
export default new VueI18n({
  locale: language ,
  fallbackLocale: appConfig.defaultLang,
  messages
})
